import { render } from "./HorizontalLine.vue?vue&type=template&id=391f3b83&scoped=true"
const script = {}

import "./HorizontalLine.vue?vue&type=style&index=0&id=391f3b83&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-391f3b83"]])

export default __exports__